import { render, staticRenderFns } from "./talentCultivationTable.vue?vue&type=template&id=f28dcfb2&scoped=true"
import script from "./talentCultivationTable.vue?vue&type=script&lang=js"
export * from "./talentCultivationTable.vue?vue&type=script&lang=js"
import style0 from "./talentCultivationTable.vue?vue&type=style&index=0&id=f28dcfb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28dcfb2",
  null
  
)

export default component.exports